import * as React from 'react';
import { useForm, useFormState, useFormContext, useWatch, useFieldArray, Controller } from 'react-hook-form';
import { Box, Button, Typography, useMediaQuery, TextField as MuiTextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import {
    List,
    Datagrid,
    TextField,
    ReferenceField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    ReferenceInput,
    SelectInput,
    TextInput,
    SimpleList,
    ShowButton,
    FunctionField,
    useTranslate,
    ReferenceManyField,
    SingleFieldList,
    ChipField,
    DateTimeInput,
    PasswordInput,
    ImageInput,
    ImageField,
    TabbedForm,
    FormTab,
    FormDataConsumer,
    AutocompleteArrayInput,
    ArrayInput,
    SimpleFormIterator,
    useRecordContext,
    Loading,
    useGetIdentity,
    useCreate,
    useRedirect,
    useNotify,
    Toolbar,
    SaveButton
} from 'react-admin';
import imageCompression from 'browser-image-compression';
import { formatDate, getUUID, getValidationErrors, uploadImageToFirebaseStorage } from '../utils/util';
import { Consts } from '../consts/Const';
import { display } from '@mui/system';
import { useState } from 'react';
import { AddAlarmSharp, ConstructionOutlined, OpenInNewOffOutlined, RecentActorsOutlined } from '@mui/icons-material';
import { CustomFormTab, TabBasic } from './RecommendFormComponents';
import Error from '../Error';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { storage } from '../firebase';
import CustomBreadcrumbs from '../layout/Breadcrumbs';

const ContestTitle = ({ record }: any) => {
    return <span>Contest {record ? `"${record.title}"` : ''}</span>;
};

const PostCreateToolbar = (props: any) => {
    const { isSubmitting, ...rest } = props;
    const redirect = useRedirect();
    const notify = useNotify();
    return (
        <Toolbar {...rest}>
            <SaveButton disabled={isSubmitting} label="保存" />
            {/* <SaveButton
                label="post.action.save_and_add"
                mutationOptions={{
                    onSuccess: data => {
                        notify('ra.notification.created', {
                            type: 'info',
                            messageArgs: { smart_count: 1 },
                        });
                        redirect(false);
                    }}
                }
                type="button"
                variant="text"
            /> */}
        </Toolbar>
    );
};

const RecommendCreateContent = ({ currentUser, onSubmit, isSubmitting }: any) => {
    // 権限別調整
    let isNotPermitted;
    switch (currentUser.authority) {
        case Consts.AUTORITY.area:
            break;
        case Consts.AUTORITY.mall:
            isNotPermitted = true;
            break;
        case Consts.AUTORITY.maker:
            isNotPermitted = true;
            break;
        default:
            break;
    }

    if (isNotPermitted) return <Error type="permission" />;

    return (
        <CustomFormTab
            onSubmit={onSubmit}
            currentUser={currentUser}
            toolbar={<PostCreateToolbar isSubmitting={isSubmitting} />}
        />
    );
};

export const RecommendCreate = () => {
    const { identity: currentUser, isLoading } = useGetIdentity();
    const [create] = useCreate();
    const redirect = useRedirect();
    const notify = useNotify();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onSubmit = async (data: any) => {
        setIsSubmitting(true);
        // バリデーションのみ、imageUrlは、バリデーションのため一時的に、rawFileのファイル名を入れておく。
        try {
            await create(
                'recommends',
                {
                    data: {
                        isValidationOnly: true,
                        ...data,
                        imageUrl: data.imageUrl ? data.imageUrl.rawFile.name : null
                    }
                },
                { returnPromise: true }
            );
        } catch (error: any) {
            setIsSubmitting(false);
            const validationErrors = getValidationErrors(error);
            return validationErrors;
        }

        // 画像のアップロード処理
        try {
            if (data.imageUrl) {
                data.imageUrl = await uploadImageToFirebaseStorage(data.imageUrl.rawFile, data.areaId, 'recommends');
            }
        } catch (error: any) {
            setIsSubmitting(false);
            return {
                imageUrl: '画像のアップロードに失敗しました。適切な画像を選択し直してください。'
            };
        }

        // formの送信
        try {
            await create('recommends', { data: data }, { returnPromise: true });
            notify('resources.contests.notification.created_success', { type: 'success' });
            redirect('/recommends');
        } catch (error: any) {
            setIsSubmitting(false);
            const validationErrors = getValidationErrors(error);
            return validationErrors;
        }

        setIsSubmitting(false);
    };

    if (isLoading) return <Loading />;

    return (
        <>
            <CustomBreadcrumbs
                breadcrumbs={[
                    { url: '/recommends', text: 'おすすめコンテンツ一覧' },
                    { url: null, text: `おすすめコンテンツ新規登録` }
                ]}
            />
            <Create
                title={'おすすめコンテンツ新規登録'}
                sx={{
                    padding: {
                        // xs: '20px 10px',
                        sm: '0px 0px 20px'
                    }
                }}
            >
                <RecommendCreateContent currentUser={currentUser} onSubmit={onSubmit} isSubmitting={isSubmitting} />
            </Create>
        </>
    );
};
